const n={error10:{main:"#FAE6E4"},error100:{main:"#F44336"},success10:{main:"#E5F8E0"},success100:{main:"#4CAF50"},warning10:{main:"#FFFBDC"},warning100:{main:"#FFC107"}};export{n as default};
//# sourceMappingURL=actions.js.map
